import { createContext, useContext } from "react";

/**
 * Reports a connection that finished inside the side panel, so the surface hosting the flows can
 * react to it the same way it reacts to one finished by `ConnectionAuthCallbackHandler` itself.
 *
 * Marketing/analytics connectors are the ones that need this: they return from OAuth with accounts
 * still to pick, so the completing POST happens in the panel rather than in the handler.
 */
export type ReportConnectionCompleted = (params: URLSearchParams) => void;

export const ConnectionCompletionContext = createContext<ReportConnectionCompleted>(() => undefined);

export const useReportConnectionCompleted = (): ReportConnectionCompleted => useContext(ConnectionCompletionContext);
